module.exports = __webpack_public_path__ + "static/media/103.eda3378d.jpg";